import { createSelector } from 'reselect';


export const getIsVtypeFetched = (state, props) => state.vtype.params.vtypeFetched;
export const getVtypeList = (state, prop) => state.vtype.byId
export const getEditedRes = (state, prop) => state.vtype.saveEditedResponse
export const getNotification = (state, id) => state.vtype.notifications[id]


export const getFilteredVtype = createSelector(
    getVtypeList,
    (vtype) => {
        let filteredVtype = Object.keys(vtype).map(function (key) {
            return vtype[key];
        })
        return filteredVtype;
    }
)

export const getFilteredVtypeForDD = createSelector(
    getVtypeList,
    (vtype) => {
        const keys = Object.keys(vtype)
        let obj = [{
            key: "All",
            value: "All",
            text: "All"
        }]
        keys.map((key) => { 
            obj.push({ key: vtype[key].trans_type, value: vtype[key].trans_type, text: vtype[key].trans_type })
        })
        return obj
    }
)
